import Vue from 'vue';
import Vuex from 'vuex';

import labelsFR from '../data/translations/locales_fr.json';
import countriesFR from '../data/country_codes/countries_fr.json';

import stocks from './modules/stocks/index.js';
import crudData from './modules/crudData/index.js';
import products from './modules/products/index.js';
import users from './modules/users/index.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    stocks,
    crudData,
    products,
    users,
  },
  state: {
    labels: labelsFR,
    importType: '',
    countries: {
      fr: countriesFR,
    },
    sessionUser: readJSON('user'),
    roles: [],
    firebaseSignin: false,
  },
  mutations: {
    UPDATE_IMPORT_TYPE(state, type) {
      state.importType = type;
    },
    SET_USER_INFO(state, user) {
      console.log('set User info');
      state.sessionUser = user;
      storeJSON(user, 'user');
      if (user) {
        configPreviewProductData(user, state);
      }
    },
    SET_FIREBASE_SIGNIN(state, value) {
      console.log('SET_FIREBASE_SIGNIN', value);
      state.firebaseSignin = value;
    },
  },
  actions: {
    updateImportType({ commit }, type) {
      commit('UPDATE_IMPORT_TYPE', type);
    },
    setUserInfo({ commit }, user) {
      commit('SET_USER_INFO', user);
    },
    setFirebaseSignin({ commit }, value) {
      commit('SET_FIREBASE_SIGNIN', value);
    },
  },
  getters: {
    adminRole: (state) => {
      let admin = [];
      if (state.sessionUser && state.sessionUser.roles) {
        admin = state.sessionUser.roles.filter((role) => role === 'ROLE_ADMIN' || role === 'ROLE_ADMIN_PLUS');
      }
      return admin.length;
    },
    canEditProduct: (state) => (state.sessionUser && state.sessionUser.roles) && (state.sessionUser.roles[0] === 'ROLE_ADMIN_PLUS' || state.sessionUser.roles[0] === 'ROLE_ADMIN' || state.sessionUser.roles[0] === 'ROLE_RESEARCH'),
    canDeleteProduct: (state) => (state.sessionUser && state.sessionUser.roles) && (state.sessionUser.roles[0] === 'ROLE_ADMIN_PLUS' || state.sessionUser.roles[0] === 'ROLE_ADMIN'),
    canDuplicateProduct: (state) => (state.sessionUser && state.sessionUser.roles) && (state.sessionUser.roles[0] === 'ROLE_ADMIN_PLUS' || state.sessionUser.roles[0] === 'ROLE_ADMIN'),
    productAccess: (state) => {
      if (state.sessionUser && state.sessionUser.roles) {
        switch (state.sessionUser.roles[0]) {
          case 'ROLE_ADMIN_PLUS':
            return true;
          case 'ROLE_ADMIN':
            return true;
          case 'ROLE_RESEARCH':
            return true;
          case 'ROLE_MARKETING':
            return true;
          case 'ROLE_MARKETING_PLUS':
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    stockAccess: (state) => {
      if (state.sessionUser && state.sessionUser.roles) {
        switch (state.sessionUser.roles[0]) {
          case 'ROLE_ADMIN_PLUS':
            return true;
          case 'ROLE_ADMIN':
            return true;
          case 'ROLE_RESEARCH':
            return false;
          case 'ROLE_MARKETING':
            return false;
          case 'ROLE_MARKETING_PLUS':
            return false;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    stockAccessRead: (state) => {
      if (state.sessionUser && state.sessionUser.roles) {
        switch (state.sessionUser.roles[0]) {
          case 'ROLE_ADMIN_PLUS':
            return true;
          case 'ROLE_ADMIN':
            return true;
          case 'ROLE_RESEARCH':
            return true;
          case 'ROLE_MARKETING':
            return true;
          case 'ROLE_MARKETING_PLUS':
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    resourceAccess: (state) => {
      if (state.sessionUser && state.sessionUser.roles) {
        switch (state.sessionUser.roles[0]) {
          case 'ROLE_ADMIN_PLUS':
            return true;
          case 'ROLE_ADMIN':
            return true;
          case 'ROLE_RESEARCH':
            return false;
          case 'ROLE_MARKETING':
            return false;
          case 'ROLE_MARKETING_PLUS':
            return false;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    userAccess: (state) => (state.sessionUser && state.sessionUser.roles) && state.sessionUser.roles[0] === 'ROLE_ADMIN_PLUS',
    fullProductManagementAccess: (state) => (state.sessionUser && state.sessionUser.roles) && (state.sessionUser.roles[0] === 'ROLE_ADMIN_PLUS' || state.sessionUser.roles[0] === 'ROLE_ADMIN'),
    marketingRole: (state) => state.sessionUser && (state.sessionUser.roles[0] === 'ROLE_MARKETING' || state.sessionUser.roles[0] === 'ROLE_MARKETING_PLUS'),
    researchRole: (state) => state.sessionUser && (state.sessionUser.roles[0] === 'ROLE_RESEARCH'),
  },
});

function storeJSON(data, name) {
  const stringJSON = JSON.stringify(data);
  localStorage.setItem(name, stringJSON);
}

function readJSON(name) {
  const parsedData = JSON.parse(localStorage.getItem(name));
  return parsedData || null;
}

function configPreviewProductData(user, state) {
  if (user && (user.roles[0] === 'ROLE_MARKETING' || user.roles[0] === 'ROLE_MARKETING_PLUS')) {
    delete state.products.previewProductBlocks.roles.ingredient;
  }
}



// WEBPACK FOOTER //
// ./src/store/store.js